import { useParams } from 'react-router-dom'

import { FaceRecognitionLogsPageDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import FaceRecognitionLogs from 'modules/employees/components/FaceRecognition/Logs'

const FaceRecognitionLogsPage = () => {
  const { employeeId } = useParams()
  const { data, loading } = useQuery(FaceRecognitionLogsPageDocument, {
    variables: { employeeId: Number(employeeId) },
  })
  const employeeFullName = data?.employees?.employee?.fullName || ''
  const contractStartsOnValue = data?.employees?.employee?.referenceContract?.startsOn
  const contractStartsOn = contractStartsOnValue ? new Date(contractStartsOnValue) : null

  return (
    !loading && (
      <FaceRecognitionLogs
        employeeId={Number(employeeId)}
        employeeFullName={employeeFullName}
        contractStartsOn={contractStartsOn}
      />
    )
  )
}

export default FaceRecognitionLogsPage
